import { useMemo } from 'react';
import classNames from 'classnames';
import { useStrapiGlobal } from '@/context';

type FooterBottomProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-footer__bottom';

export const FooterConferenciasBottom = ({ className }: FooterBottomProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);
	const { layout } = useStrapiGlobal();
	const { footer } = layout;
	const { bottom } = footer;
	const { copyright, ctLogo } = bottom;

	return (
		<footer className={wrapperClassName}>
			<div className={`${classNameComponent}-content`}>
				<div className={`${classNameComponent}-row`}>
					<p className={`${classNameComponent}-copyright`}>{copyright}</p>
					<img className={`${classNameComponent}-ctlogo`} src={ctLogo.url} alt={ctLogo.alt} />
				</div>
			</div>
		</footer>
	);
};
